import JSONAPIAdapter from '@ember-data/adapter/json-api';
import ENV from 'bullitttime-uploader/config/environment';

export default class ApplicationAdapter extends JSONAPIAdapter 
{
	host = ENV.uploaderBackendProtocol+"://"+ENV.uploaderBackendHost+":"+ENV.uploaderBackendPort;
	namespace = ENV.uploaderBackendNamespace;
	coalesceFindRequests = true;
}
